import { type MetricType } from 'domains/aggregate-store-performance/api'
import {
  type StoreMetric,
  type HistoricalStorePerformanceOverviewMetrics,
} from 'domains/aggregate-store-performance/types/AggregateStorePerformance.types'

export const MAX_WEEKS_IN_FUTURE_EDITABLE = 3 as const

export const TRACKING = {
  pageLoad: {
    id: 'staffing.stores.page_viewed',
    description: 'Viewed the Aggregate Store Performance page',
  },
  dateSelection: {
    id: 'staffing.stores.date_selection.changed',
    description: 'Changed the selected date on the Aggregate Store Performance page',
  },
  sorting: {
    id: 'staffing.stores.table.sorting.changed',
    description: 'Changed the sorting on the Aggregate Store Performance page table',
  },
  editSchedule: {
    id: 'staffing.stores.table.edit_schedule',
    description: 'Edit Schedule button in the stores metrics table clicked',
  },
  storeName: {
    id: 'staffing.stores.table.store_name',
    description: 'Store Name link in the stores metrics table clicked',
  },
  pickupAnalytics: {
    id: 'staffing.stores.pickup_analytics',
    description: 'Stores page Pickup Analytics link clicked',
  },
  export: {
    id: 'staffing.stores.export',
    description: 'Stores page Export button clicked',
  },
  filters: {
    id: 'staffing.stores.filters',
    description: 'Stores page filters changed',
  },
} as const

export const HISTORICAL_STORE_METRIC_COLUMN_ORDER: Array<keyof StoreMetric> = [
  'storeName',
  'hoursScheduled',
  'hoursRecommended',
  'scheduleGaps',
  'matchRate',
  'utilization',
  'fiveHourAvailability',
  'partnerPickOrders',
  'fullServiceShopperOrders',
]

export const HISTORICAL_DEDICATED_STORE_METRIC_COLUMN_ORDER: Array<keyof StoreMetric> = [
  'storeName',
  'hoursScheduled',
  'hoursRecommended',
  'scheduleGaps',
  'dedicatedMatchRate',
  'dedicatedUtilization',
  'fiveHourAvailability',
  'partnerPickOrders',
  'fullServiceShopperOrders',
]

// beyond this date in the past we have no data
export const PAST_DATA_CUTOFF_DATE = '2021-06-21'

// beyond this date in the past we have no data for historical metrics
export const HISTORICAL_METRICS_PAST_DATA_CUTOFF_DATE = '2021-10-18'

// The maximum number weeks in the future we have data
export const MAX_WEEK_OFFSET = 2

export const metricTypeToFieldName: Record<
  Exclude<MetricType, MetricType.Default | MetricType.StaffingRate>,
  keyof StoreMetric
> = {
  SCHEDULED_HOURS: 'hoursScheduled',
  RECOMMENDED_HOURS: 'hoursRecommended',
  SCHEDULED_GAPS: 'scheduleGaps',
  MATCH_RATE: 'matchRate',
  DEDICATED_MATCH_RATE: 'dedicatedMatchRate',
  UTILIZATION_RATE: 'utilization',
  DEDICATED_UTILIZATION_RATE: 'dedicatedUtilization',
  FIVE_HOUR_AVAILABILITY_RATE: 'fiveHourAvailability',
  FULFILLED_ORDERS: 'fulfilledOrders',
}

export const metricTypeToFieldTrend: Record<
  Exclude<
    MetricType,
    | MetricType.Default
    | MetricType.StaffingRate
    | MetricType.ScheduledHours
    | MetricType.RecommendedHours
  >,
  keyof HistoricalStorePerformanceOverviewMetrics
> = {
  SCHEDULED_GAPS: 'scheduleGapsTrend',
  MATCH_RATE: 'matchRateTrend',
  DEDICATED_MATCH_RATE: 'dedicatedMatchRateTrend',
  UTILIZATION_RATE: 'utilizationTrend',
  DEDICATED_UTILIZATION_RATE: 'dedicatedUtilizationTrend',
  FIVE_HOUR_AVAILABILITY_RATE: 'fiveHourAvailabilityTrend',
  FULFILLED_ORDERS: 'fulfilledOrdersTrend',
}
